import React, { useState, useRef, useEffect } from "react";
import { createPortal } from "react-dom";

const PopoverContent = ({ content, position, onClose }) => {
  const popoverRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popoverRef.current && !popoverRef.current.contains(event.target)) {
        onClose();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);

  return createPortal(
    <div
      ref={popoverRef}
      style={{
        position: "absolute",
        left: `${position.left}px`,
        top: `${position.top}px`,
        zIndex: 1000,
        backgroundColor: "#333",
        color: "#fff",
        borderRadius: "4px",
        padding: "6px 10px",
        fontSize: "12px",
        whiteSpace: "nowrap",
        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
        transform: "translateX(-50%)",
      }}
    >
      {content}
      <div
        style={{
          position: "absolute",
          bottom: "-5px",
          left: "50%",
          transform: "translateX(-50%)",
          width: 0,
          height: 0,
          borderLeft: "5px solid transparent",
          borderRight: "5px solid transparent",
          borderTop: "5px solid #333",
        }}
      />
    </div>,
    document.body
  );
};

const DraftComponent = (props) => {
  const context = props.context.componentParent;
  const indent = props.data.indent || {};

  const [showPopover, setShowPopover] = useState(false);
  const [popoverText, setPopoverText] = useState("");
  const [position, setPosition] = useState({ left: 0, top: 0 });

  const handleClickDelete = (e) => {
    e.stopPropagation();
    context.deletedraftindent(props);
  };

  const handleEdit = (e) => {
    e.stopPropagation();
    if (indent && indent._id) {
      window.location.href = `/editrfq/${indent._id}`;
    }
  };

  const handleMouseEnter = (e, text) => {
    const rect = e.currentTarget.getBoundingClientRect();
    setPosition({
      left: rect.left + rect.width / 2,
      top: rect.top - 35 + window.scrollY,
    });
    setPopoverText(text);
    setShowPopover(true);
  };

  const handleMouseLeave = () => {
    setShowPopover(false);
  };

  return (
    <div style={{ display: "flex", gap: "5px", position: "relative" }}>
      {indent.is_draft === 1 && (
        <>
          {/* Edit Button */}
          <button
            onClick={handleEdit}
            className="custom-btn label label-success"
            onMouseEnter={(e) => handleMouseEnter(e, "Edit Draft")}
            onMouseLeave={handleMouseLeave}
          >
            <img
              src={require("../../assets/icons/pencil.svg")}
              alt="Edit Draft"
              style={{
                cursor: "pointer",
                height: "13px",
                position: "relative",
              }}
            />
          </button>

          {/* Delete Button */}
          <button
            onClick={handleClickDelete}
            className="custom-btn label label-success"
            onMouseEnter={(e) => handleMouseEnter(e, "Delete Draft")}
            onMouseLeave={handleMouseLeave}
          >
            <img
              src={require("../../assets/icons/delete.svg")}
              alt="Delete Draft"
              style={{
                cursor: "pointer",
                height: "13px",
                position: "relative",
              }}
            />
          </button>
        </>
      )}

      {showPopover && (
        <PopoverContent
          content={popoverText}
          position={position}
          onClose={() => setShowPopover(false)}
        />
      )}
    </div>
  );
};

export default DraftComponent;
